import { render, staticRenderFns } from "./features-settings-page.vue?vue&type=template&id=44ec73a0&scoped=true&"
import script from "./features-settings-page.vue?vue&type=script&lang=js&"
export * from "./features-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./features-settings-page.vue?vue&type=style&index=0&id=44ec73a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec73a0",
  null
  
)

export default component.exports